module.exports = __webpack_public_path__ + "img/p16.7012b74f.png";